export class Oficina {
    nomOficina: string;
    codOficina: number
}
